// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.otp-phone-num {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
}
.otp-phone-num .phone-icon {
  border-radius: 40px;
  background: var(--sdk-gloabl-bg-secondary);
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.otp-phone-num .phone-icon svg path {
  stroke: var(--sdk-gloabl-text-color);
}
.otp-phone-num p {
  color: var(--sdk-gloabl-text-color);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  width: 100%;
}

.otp-input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.otp-input-wrapper p {
  color: var(--sdk-gloabl-text-color);
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  margin: 0;
}
.otp-input-wrapper .otp-inputs {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
}
.otp-input-wrapper .otp-inputs input {
  width: 100%;
  border-radius: 8px;
  border: 1px solid var(--sdk-gloabl-border-color);
  background: var(--sdk-global-white-bg);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  height: 48px;
  padding: 2px 8px;
  text-align: center;
  color: var(--sdk-gloabl-text-color);
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
}
.otp-input-wrapper .otp-inputs input::placeholder {
  color: var(--sdk-gloabl-text-color);
  opacity: 0.4;
  font-size: 24px;
  font-weight: 500;
  line-height: 32px;
}
.otp-input-wrapper .text-info-otp {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  align-items: center;
  gap: 4px;
}
.otp-input-wrapper .text-info-otp button {
  border: 0;
  padding: 0;
  background: transparent;
  color: var(--sdk-global-theme-color);
  text-decoration-line: underline;
  font-size: 14px;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/otp/otp.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AACJ;AAAI;EACI,mBAAA;EACA,0CAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAER;AAAY;EACI,oCAAA;AAEhB;AAEI;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;AAAR;;AAGA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAAJ;AACI;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;AACR;AACI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;AACR;AAAQ;EACI,WAAA;EACA,kBAAA;EACA,gDAAA;EACA,sCAAA;EACA,kDAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAEZ;AADY;EACI,mCAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAGhB;AACI;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AACR;AAAQ;EACI,SAAA;EACA,UAAA;EACA,uBAAA;EACA,oCAAA;EACA,+BAAA;EACA,eAAA;EACA,eAAA;AAEZ","sourcesContent":[".otp-phone-num{\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    width: 100%;\n    .phone-icon{\n        border-radius: 40px;\n        background: var(--sdk-gloabl-bg-secondary);\n        width: 32px;\n        height: 32px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        flex-shrink: 0;\n        svg{\n            path{\n                stroke:var(--sdk-gloabl-text-color);\n            }\n        }\n    }\n    p{\n        color: var(--sdk-gloabl-text-color);\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 18px;\n        width: 100%;\n    }\n}\n.otp-input-wrapper{\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    p{\n        color: var(--sdk-gloabl-text-color);\n        font-size: 12px;\n        font-weight: 500;\n        line-height: 18px;\n        margin: 0;\n    }\n    .otp-inputs{\n        display: flex;\n        align-items: center;\n        width: 100%;\n        gap: 10px;\n        input{\n            width: 100%;\n            border-radius: 8px;\n            border: 1px solid var(--sdk-gloabl-border-color);\n            background: var(--sdk-global-white-bg);\n            box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);\n            height: 48px;\n            padding: 2px 8px;\n            text-align: center;\n            color: var(--sdk-gloabl-text-color);\n            font-size: 24px;\n            font-weight: 500;\n            line-height: 32px;\n            &::placeholder{\n                color: var(--sdk-gloabl-text-color);\n                opacity: 0.4;\n                font-size: 24px;\n                font-weight: 500;\n                line-height: 32px;\n            }\n        }\n    }\n    .text-info-otp{\n        color: var(--sdk-gloabl-text-color);\n        font-size: 14px;\n        font-weight: 400;\n        line-height: 20px;\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        button{\n            border: 0;\n            padding: 0;\n            background: transparent;\n            color: var(--sdk-global-theme-color);\n            text-decoration-line: underline;\n            font-size: 14px;\n            cursor: pointer;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
